const VERSION = 'fb';
const SUBDOMAIN_INDEX = 1;

enum PixelIds {
  FBP = '__tt_fbp',
  FBC = '__tt_fbc',
  FBCLID = 'fbclid',
}

const getRandomNumber = () => +Math.random().toString().replace('.', '');

// FBP id for pixel
// https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/fbp-and-fbc/
const setFBP = () => {
  const creationTime = Date.now();
  const randomNumber = getRandomNumber();
  const fbp = [VERSION, SUBDOMAIN_INDEX, creationTime, randomNumber].join('.');
  // TODO: Create a wrapper around localStorage.
  globalThis.localStorage.setItem(PixelIds.FBP, fbp);
  return fbp;
};

const setFBC = (fbclid: string) => {
  const creationTime = Date.now();
  const fbc = [VERSION, SUBDOMAIN_INDEX, creationTime, fbclid].join('.');
  globalThis.localStorage.setItem(PixelIds.FBC, fbc);
  return fbc;
};

const getFBP = () => globalThis.localStorage.getItem(PixelIds.FBP);

const getFBC = () => globalThis.localStorage.getItem(PixelIds.FBC);

const initializePixel = () => {
  try {
    let fbp = getFBP();
    if (!fbp) {
      fbp = setFBP();
    }

    const searchParams = new URLSearchParams(globalThis.location.search);
    const fbclid = searchParams.get(PixelIds.FBCLID);
    let fbc = getFBC();

    if (fbclid) {
      // Looks like we have got a new fbclid, regenerate fbc.
      fbc = setFBC(fbclid);
    }

    return { fbp, fbc };
  } catch (error) {
    //
  }
  return null;
};

const resetPixel = () => {
  globalThis.localStorage.removeItem(PixelIds.FBC);
};

export { getFBC, getFBP, initializePixel, resetPixel, setFBC, setFBP };
